import { render, staticRenderFns } from "./DetailCard.vue?vue&type=template&id=0666ef74"
import script from "./DetailCard.ts?vue&type=script&lang=ts&external"
export * from "./DetailCard.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports